module.exports = __webpack_public_path__ + "static/media/main_yellow_button.5627135d.jpg";